<template>
    <div @click.stop="onClick"
         :class="{ 'fixed top-0 left-0 w-full h-full text-base bg-light-gray overflow-y-auto pt-26 pb-4 z-30': open }"
         class="flex flex-col gap-2 lg:static lg:bg-transparent lg:p-0 lg:h-auto lg:p-auto lg:text-sm">
        <div v-if="open" class="flex items-center gap-2 cursor-pointer lg:hidden" @click.stop="open = false">
            <icon name="chevron" class="w-3 h-3 transform rotate-90 fill-current"/>
            <span class="text-xs font-bold">{{ backLabel }}</span>
        </div>
        <div class="font-bold lg:font-sans lg:normal-case lg:mt-0" :class="{'font-heading uppercase mt-1': open}">
            <slot />
        </div>
        <slot name="items" :open="open" />
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Icon from '../base/Icon.vue';

@Component({
    components: { Icon }
})
export default class FooterNavItem extends Vue {
    @Prop({ required: true }) link: string;
    @Prop({ required: true }) backLabel: string;

    open = false;

    onClick(event: MouseEvent) {
        if (!this.open) {
            event.stopPropagation();
            this.open = true;
        }
    }

    @Watch('open')
    openChanged() {
        if (this.open) {
            document.body.classList.add('overflow-hidden');
        } else {
            document.body.classList.remove('overflow-hidden');
        }
    }
}
</script>
